<div class="send-notification-tab-content">
    <div class="send-notofication-tab-content-action">
        <h3 class="select-notification-action">Select Notification</h3>
        <div class="sent-notification-history-action">
            <a
                mat-flat-button
                [routerLink]="['/push-notifications-history']"
            >
                Sent Notification History
            </a>
        </div>
    </div>
    <div class="send-notofication-tab-content-action-list">
        <mat-list>
            <mat-list-item
                class="notification-list-item"
                *ngFor="let notification of notifications"
            >
                <div class="notification-list-content">
                    <div class="notification-list-item-section">
                        <mat-radio-button (click)="openSendNotificationDialog(notification)"></mat-radio-button>
                    </div>
                    <div class="notification-list-item-image">
                        <img
                            *ngIf="notification?.imageUrl"
                            src="{{notification?.imageUrl}}"
                            [attr.alt]="notification?.title"
                        >
                    </div>
                    <div class="notification-list-item-text">
                        <h4>{{notification?.title}}</h4>
                        <p>{{notification?.description}}</p>
                        <p>{{notification?.link}}</p>
                    </div>
                    <div class="notification-list-item-action">
                        <a
                            mat-flat-button
                            (click)="openDeleteNotificationDialog(notification)"
                        >
                            Delete
                        </a>
                    </div>
                </div>

            </mat-list-item>
        </mat-list>
    </div>
</div>
